module.exports = __webpack_public_path__ + "static/media/works2.36b4f8ac.png";